var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("validation-provider", {
    attrs: {
      vid: _vm.vid,
      rules: _vm.validation,
      name: _vm.errorName || _vm.label,
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ errors }) {
          return [
            _c(
              "brb-uploader",
              _vm._g(
                _vm._b(
                  {
                    attrs: {
                      label: _vm.label,
                      required: _vm.required,
                      error: errors && errors.length ? errors[0] : undefined,
                    },
                    model: {
                      value: _vm.model,
                      callback: function ($$v) {
                        _vm.model = $$v
                      },
                      expression: "model",
                    },
                  },
                  "brb-uploader",
                  _vm.$attrs,
                  false
                ),
                _vm.$listeners
              )
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }